import styles from '@ui/components/Voting/components/Answers/Answers.module.scss';
import Heading from '@ui/components/Heading/Heading';
import React from 'react';
import { Radio, RadioGroup } from '@ariakit/react';
import PropTypes from 'prop-types';

const Answers = ({ answers, id, question, store }) => (
  <RadioGroup
    aria-labelledby={`${id}-${question}`}
    className={styles.container}
    id={id}
    store={store}
  >
    <Heading
      align="center"
      as="div"
      className={styles.question}
      id={`${id}-${question}`}
      size="h4"
    >
      {question}
    </Heading>
    {answers.map(answer => (
      <label
        className={styles.answer}
        htmlFor={`${id}-${answer}`}
        key={`${id}-${answer}`}
      >
        <Radio
          className={styles.switchRadio}
          id={`${id}-${answer}`}
          store={store}
          value={answer}
        />
        {answer}
      </label>
    ))}
  </RadioGroup>
);

Answers.propTypes = {
  answers: PropTypes.arrayOf(PropTypes.string).isRequired,
  id: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  /* eslint-disable react/forbid-prop-types */
  /** `useRadioStore()` return value from `@ariakit/react` */
  store: PropTypes.object.isRequired,
  /* eslint-enable react/forbid-prop-types */
};

export default Answers;
